import * as types from '../actions/productsActions';

const initialState = {
    products: [],
    purchasedProducts: [],
    loading: false,
    error: null,
    invoice:null
}


function productsReducer(state = initialState, action) {
    switch (action.type) {
        case types.PURCHASED_PRODUCTS_LIST_REQUEST:
        case types.PRODUCTS_BUY_REQUEST:
        case types.PRODUCTS_LIST_REQUEST:
        case types.PRODUCTS_REDEEM_REQUEST:
            return Object.assign({}, state, {
                loading: true,
                error: null
            });
            break;

        case types.PRODUCTS_LIST_SUCCESS:
            console.log("PLS", action)
            return Object.assign({}, state, {
                products: action.payload.products,
                loading: false,
                error: null
            });
            break;

        case types.PURCHASED_PRODUCTS_LIST_SUCCESS:
            return Object.assign({}, state, {
                purchasedProducts: action.purchased_products.sort((a, b) => (b.redeemedDate == null) - (a.redeemedDate == null) || ('' + b.redeemedDate).localeCompare(a.redeemedDate) || ('' + b.created).localeCompare(a.created)),
                loading: false,
                error: null
            });
            break;

        case types.PRODUCTS_BUY_SUCCESS:
        case types.PRODUCTS_REDEEM_SUCCESS:
            var purchasedProducts = state.purchasedProducts;
            var foundIndex = purchasedProducts.findIndex(purchasedProduct => purchasedProduct.uuid == action.purchased_product.uuid);
            if (foundIndex == -1) {
                purchasedProducts.push(action.purchased_product)
            } else {
                purchasedProducts[foundIndex] = action.purchased_product
            }

            return Object.assign({}, state, {
                purchasedProducts: purchasedProducts.sort((a, b) => (b.redeemedDate == null) - (a.redeemedDate == null) || ('' + b.redeemedDate).localeCompare(a.redeemedDate) || ('' + b.created).localeCompare(a.created)),
                loading: false,
                error: null
            });
            break;

        case types.PURCHASED_PRODUCTS_LIST_FAILURE:
        case types.PRODUCTS_BUY_FAILURE:
        case types.PRODUCTS_LIST_FAILURE:
        case types.PRODUCTS_REDEEM_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.error
            });
            break;
        case types.GENERATE_INVOICE_REQUEST:
            return Object.assign({}, state, {
                loading: true,
                error: null
             });
            break;
        case types.GENERATE_INVOICE_SUCCESS:
            return Object.assign({}, state, {
                invoice: action.invoice,
                loading: false,
                error: null
            });
            break;
        case types.GENERATE_INVOICE_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.error
            });
            break;

        default:
            return state;
    }
}

export default productsReducer;